import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'
import $ from 'jquery'

const EMULATION_MODE_BIDS = false


/*
 * Bids Actions
 * 
 */

export function fetchBidsList(dispatch) {
    let cmd = 'FETCH_BIDS_LIST'

    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        var url = buildRequestUrl('Bids');
        axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function fetchBidError(dispatch) {
    dispatch(
        {
            type: 'FETCH_BID_ERROR',
        }
    )
}

export function createBid(bid) {
    let cmd = 'CREATE_BID'
    
    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.post(buildRequestUrl('Bids'), JSON.stringify(bid), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function fetchBid(id) {
    let cmd = 'FETCH_BID';

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.get(buildRequestUrl('Bids/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function updateBid(id, bid) {
    let cmd = 'UPDATE_BID'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.put(buildRequestUrl('Bids/') + id, JSON.stringify(bid), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function errorBid(dispatch) {
    dispatch(
        {
            type: 'BID_ERROR',
        }
    )
}

export function setBidsFilters(filters) {
    this.props.dispatch(
        {
            type: 'SET_BIDS_FILTERS',
            payload: {
                data: filters
            }
        }
    )
}

export function fetchBidsValues(dispatch) {
    let cmd = 'FETCH_BIDS_VALUES'

    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        var url = buildRequestUrl('Bids/PropertyValues');
        axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function sortBid(sortBy, sortOrder) {
    this.props.dispatch(
        {
            type: 'SORT_BID',
            payload: {
                sort: sortBy,
                order: sortOrder
            }
        }
    )
}

// --  HISTORY --
export function fetchBidHistory(history) {
    let cmd = 'FETCH_BID_HISTORY'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd,
                payload: {
                    data: {
                        page: history.pageIndex
                    }
                }
            }
        )

        axios.post(buildRequestUrl('Bids/GetChangeHistoryBids'), JSON.stringify(history), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function errorBidHistory(dispatch) {

    dispatch(
        {
            type: 'BID_HISTORY_ERROR',
        }
    )
}

// -- USERS --
export function fetchBidUsers(users) {
    let cmd = 'FETCH_BID_USERS'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.post(buildRequestUrl('Bids/GetUsersByDate'), JSON.stringify(users), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function errorBidUsers(dispatch) {
    dispatch(
        {
            type: 'BID_USERS_ERROR',
        }
    )
}

// -- EXPORT --
export function export_excel_bids(dispatch, filter, second_filter, callback) {
    $('#bids *').prop('disabled', true);
    let cmd = 'FETCH_BIDS';
    let done = true;

    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd,
                payload: {
                    data: {
                        page: filter && filter.pageIndex ? filter.pageIndex : 1
                    }
                }
            });

        var stringify = {};

        stringify.StatusNames = filter;
        stringify.ActiveStatusNames = second_filter;

        dispatch(
            {
                type: 'EXPORT_START_BIDS',
                payload: {
                    data: false
                }
            }
        )

        let percComplete = 0;
        dispatch(
            {
                type: 'PERCENTAGE_COMPLETE_BIDS',
                payload: {
                    data: percComplete
                }
            }
        )

        document.getElementById("startExport").style.display = "inline";
        axios.post(buildRequestUrl('Bids_Export'), JSON.stringify(stringify),
            {
                responseType: 'blob', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                onDownloadProgress: progressEvent => {

                    dispatch(
                        {
                            type: 'FINISH_EXPORT',
                            payload: {
                                data: percComplete
                            }


                        }
                    )

                    dispatch(
                        {
                            type: 'COMPLETE_EXPORT_BIDS',
                            payload: {
                                data: true
                            }


                        }
                    )


                }
            })
            .then((resp) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Bids_Export.xlsx');
                document.body.appendChild(link);
                link.click();
                $('#bids *').prop('disabled', false);
                dispatch(
                    {
                        type: 'COMPLETE_EXPORT_BIDS',
                        payload: {
                            data: false
                        }


                    }
                )

                setTimeout("document.getElementById('startExport').style.display = 'none';", 1000);

            })
            .catch((err) => {
                //TODO:
                alert(err);
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}
